var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('v-avatar',[(_vm.temFoto == 1)?_c('img',{style:(_vm.styleImg),attrs:{"src":_vm.fotoUser,"alt":'tec_' + _vm.id}}):_c('img',{attrs:{"src":require("../assets/user_tecnico.png"),"alt":'te'}})]),_c('br')],1)}
var staticRenderFns = []

export { render, staticRenderFns }